import { Service, signal } from '@angular/core';
import { ConfirmationOptions, ConfirmationResult } from './confirmation-options.model';

@Service()
export class ConfirmationService {
  readonly activeOptions = signal<ConfirmationOptions | null>(null);

  private resolveConfirmation?: (result: ConfirmationResult) => void;

  async confirm(options: ConfirmationOptions | string): Promise<boolean> {
    const normalized = typeof options === 'string' ? { message: options } : { ...options, altText: undefined };
    return (await this.choose(normalized)) === 'confirm';
  }

  choose(options: ConfirmationOptions): Promise<ConfirmationResult> {
    // Resolve any dangling confirmation before starting a new one
    this.resolveConfirmation?.('cancel');

    this.activeOptions.set(options);
    return new Promise<ConfirmationResult>((resolve) => {
      this.resolveConfirmation = resolve;
    });
  }

  complete(result: ConfirmationResult): void {
    this.activeOptions.set(null);
    const resolve = this.resolveConfirmation;
    this.resolveConfirmation = undefined;
    resolve?.(result);
  }
}
